<template>
   <Slide :title="title" :subtitle="subtitle">
        <div class="cr:rounded-md cr:bg-yellow-50 cr:p-4">
            <div class="cr:flex">
                <div class="cr:shrink-0">
                    <svg class="cr:size-5 cr:text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                        <path fill-rule="evenodd"
                              d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
                <div class="cr:ml-3">
                    <h3 class="cr:text-sm cr:font-medium cr:text-yellow-800">Email Already Exists</h3>
                    <div class="cr:mt-2 cr:text-sm cr:text-yellow-700">
                        <p>It looks like an account with this email address is already registered. If you believe this is an error or need assistance, please contact our
                            support team:</p>
                    </div>
                    <div class="cr:mt-2 cr:text-sm cr:text-yellow-700">
                        <p>Phone: <a :href="`tel: ${configStore.supportPhone}`" class="cr:text-blue-500 cr:cursor-pointer">{{ configStore.supportPhone }}</a></p>
                        <p>Email: <a :href="`mailto: ${configStore.supportPhone}`" class="cr:text-blue-500 cr:cursor-pointer">{{ configStore.supportEmail }}</a></p>
                    </div>
                    <p class="cr:mt-2 cr:text-sm cr:text-yellow-700">We’re here to help!</p>
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import {useConfigStore} from "@/stores/config.ts";
import Slide from "@/components/slides/Slide.vue";

const configStore = useConfigStore();

const props = defineProps({
    title: {
        type: String,
        default: 'Email exists'
    },
    subtitle: {
        type: String,
        default: ""
    }
});

</script>